import { getToken } from '@nxtpeople/nxt-vue-keycloak';
import { useNxtVueEcho } from '@nxtpeople/nxt-vue-echo';
import { computed } from 'vue';
import { Batch } from '../collections/batches/batch.interface';
import { UserInfo } from '../collections/user-info/user-info.interface';
import { EchoEvents } from '../models/echo-events.interface';
import store from '../store';

export interface EchoEventResponse {
   batch: Batch;
   batch_data: Array<any>;
   connection: string;
   user: UserInfo;
}

export function useWebSockets() {
   const { echo, registerEcho, unregisterEcho } = useNxtVueEcho();

   const userChannel = computed(() => store.state.webSocket?.userChannel);
   const globalChannel = computed(() => store.state.webSocket?.globalChannel);

   async function registerWebSockets(userInfo?: UserInfo) {
      if (!userInfo) return;

      await registerEcho({
         key: import.meta.env.VITE_APP_PUSHER_KEY,
         authEndpoint: import.meta.env.VITE_APP_PUSHER_AUTH_ENDPOINT,
         cluster: import.meta.env.VITE_APP_PUSHER_CLUSTER,
         getToken,
      });

      store.commit('webSocket/SET_USER_CHANNEL', echo.value?.private(`user.${userInfo.id}`));

      userChannel.value?.listen(EchoEvents.BatchJobStarted, (data: EchoEventResponse) => {
         if (store.state.isDev) console.log(`Event started`, data.batch);
         store.commit('batch/SET_BATCH', data.batch);
      });
      userChannel.value?.listen(EchoEvents.BatchJobUpdated, (data: EchoEventResponse) => {
         if (store.state.isDev) console.log(`Event updated`, data.batch);
         store.commit('batch/SET_BATCH', data.batch);
      });
      userChannel.value?.listen(EchoEvents.BatchJobDone, (data: EchoEventResponse) => {
         if (store.state.isDev) console.log(`Event done`, data.batch);
         store.dispatch('alert/getAlertCount');
         store.commit('batch/REMOVE_BATCH', data.batch);
      });
   }

   return { registerWebSockets, unregisterEcho, echo, userChannel, globalChannel };
}
